@if (isFilial && isAdministrativo) {
  <div class="flex flex-col gap-2 text-text-enabled">
    <p class="m-0">O ramo <b>saúde</b> chegou!</p>
    <p>Contate {{ referenciaMatriz }} para conhecer essa funcionalidade.</p>
  </div>
} @else if (isAdministrativo) {
  <div class="flex flex-col gap-2 text-text-enabled">
    <p class="m-0">O ramo <b>saúde</b> chegou!</p>
    <p>
      Teste por tempo limitado e comece a oferecer este novo serviço aos seus
      clientes.
    </p>
    <span
      class="font-semibold underline cursor-pointer text-text-interactive"
      (click)="iniciarTeste()"
    >
      Iniciar teste gratuito
    </span>
  </div>
} @else {
  <p class="text-text-enabled">
    Entre em contato com o administrador da sua corretora para mais informações.
  </p>
}
